export default class UserTimezoneInformator {
    public static getUserTimezoneInWholeHours(): number {
        const timezoneOffset = UserTimezoneInformator.getTimezoneOffsetInWholeHours();
        return timezoneOffset * -1;
    }

    private static getTimezoneOffsetInWholeHours(): number {
        const userTimezoneInMinutes = new Date().getTimezoneOffset();
        return Math.floor(userTimezoneInMinutes / 60);
    }
}
